// Выбор сотрудника аутстафф
import { useEffect, useState, useMemo } from 'react';
import { useOutStaff } from 'storeZustand/outstaff';
import { useShallow } from 'zustand/react/shallow';

const useSelectedOutstaff = (staffId) => {
	const [selectedOutstaff, setSelectedOutstaff] = useState(null);

	// Все сотрудники
	const [outstaffList, getOutStaff] = useOutStaff(
		useShallow((state) => [state.outstaffList, state.getOutStaff])
	);

	// получить список доверенностей
	useEffect(() => {
		getOutStaff();
	}, []);

	// Выбранный сотрудник при редактировании
	useEffect(() => {
		if (staffId) {
			setSelectedOutstaff(staffId);
		}
	}, [staffId]);

	// Список доверенностей для селекта
	const outstaffData = useMemo(() => {
		return outstaffList?.map(({ id, surname, name, second_name }) => ({
			value: id,
			label: `${surname} ${name} ${second_name}`,
		})) ?? [];
	}, [outstaffList]);
	console.log('outstaffData', outstaffData);

	const handleSelectedOutstaff = (value) => {
		setSelectedOutstaff(value);
	}

	return {
		outstaffData,
		selectedOutstaff,
		handleSelectedOutstaff,
	};
};

export default useSelectedOutstaff;